<template>
<div class="main-container">
  <a-tabs type="card" @change="callback" >
      <a-tab-pane key="1" tab="子账号">
      <sub-account-no ref="sub"/>
      </a-tab-pane>
      <a-tab-pane key="2" tab="供应商账号">
        <supplier-account-no ref="supplier"></supplier-account-no>
      </a-tab-pane>
      <a-tab-pane key="3" tab="渠道商账号">
        <channel-account-no ref="channel"></channel-account-no>
      </a-tab-pane>
    </a-tabs>
</div>
  
</template>
<script>
import subAccountNo from "./components/subAccountNo"
import channelAccountNo from "./components/channelAccountNo"
import supplierAccountNo from "./components/supplierAccountNo"
export default {
    components:{subAccountNo,channelAccountNo,supplierAccountNo},
  data() {
    return {};
  },
  methods: {
    callback(key) {
      this.$nextTick(()=>{
        if (key == 1) {
        // console.log(key);
        this.$refs.sub.getdata(1)
      } else if (key == 2) {
        this.$refs.supplier.getdata(1);
      }else if (key == 3) {
        this.$refs.channel.getdata(1);
      }
      })
      
      // console.log(key);
    },
  },
};
</script>

<style lang="less" scoped>

</style>